<script setup lang="ts">
/**
 * Bannière cover du plan d'adhésion (avec fallback dégradé sombre + icône).
 * Karim 2026-06-15 (SEO sprint v4) : utilise <HeroImage> pour LCP optimisé.
 *
 * Fix Karim 2026-06-15 : prefixe l'URL avec apiBaseUrl (avant : URL relative
 * `/api/assets/...` cherchait sur donoor.org au lieu du backend api.donoor.org).
 */
const props = defineProps<{
  coverImageId: string | null;
  title: string;
}>();

const config = useRuntimeConfig();
// Directus direct : le proxy /api/assets NE transforme PAS (bannière servie en
// pleine résolution). Directus resize à la volée. (Audit images asso 2026-07-31.)
const assetsBaseUrl =
  (config.public.apiUrl as string) || "https://api.donoor.org";

const heroSrc = computed(() =>
  props.coverImageId
    ? `${assetsBaseUrl}/api/assets/${props.coverImageId}?width=1920&height=400&fit=cover&format=webp&quality=80`
    : null,
);
</script>

<template>
  <div>
    <!-- ⚠️ BANNIÈRE FIXE, LA PAGE GLISSE PAR-DESSUS (Karim 2026-08-23, même
         traitement que la boutique et la billetterie).
         `fixed` et NON `sticky` : `html`/`body` portent `overflow-x: clip`
         (garde anti-débordement, main.css), et `clip` neutralise
         `position: sticky` — mesuré, la bannière défilait malgré `top-0`.
         `z-0` et non `-z-10` : en z-index négatif elle passerait derrière le
         fond de page ET derrière son propre espaceur opaque, donc invisible. -->
    <div class="fixed inset-x-0 top-0 z-0">
      <div class="w-full h-[200px] md:h-[250px] overflow-hidden">
        <HeroImage
          v-if="heroSrc"
          :src="heroSrc"
          :alt="title"
          img-class="w-full h-full object-cover"
        />
        <div
          v-else
          class="w-full h-full bg-linear-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] flex items-center justify-center"
        >
          <div class="text-center">
            <UIcon name="i-lucide-id-card" class="size-12 text-white/20 mx-auto mb-2" />
            <p class="text-white/30 text-sm font-medium">{{ title }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Espaceur : réserve la hauteur de la bannière, qui est sortie du flux. -->
    <div class="h-[200px] md:h-[250px] pointer-events-none" />
  </div>
</template>
